module.exports = __webpack_public_path__ + "static/media/prec-btn.167e4714.png";